import { Card, Descriptions, Form, InputNumber } from 'antd';
import { RevxButton } from 'components/RevxButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NOT_APPLICABLE } from 'utils/constants';

export type ElementMarkupCardProps = {
  markup: number | null;
  industryAvg: number | null;
  onSave: (v: number | null) => void;
  title: string;
  noMarkupCount: number;
  noMarkupLabel: string;
  onJump: () => void;
  allMarkupLabel: string;
};

const ElementMarkupCard = (props: ElementMarkupCardProps) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const onFinish = () => {
    props.onSave(form.getFieldValue('markup'));
  };
  return (
    // @ts-ignore
    <Card title={t(props.title)}>
      {props.markup === null ? (
        <>
          <span>{t('platform.markup.labels.none')}</span>
          <RevxButton
            type="link"
            size="large"
            onClick={() => props.onSave(props.industryAvg || 0)}
          >
            {t('platform.markup.labels.initialize')}
          </RevxButton>
        </>
      ) : (
        <Form
          layout="inline"
          form={form}
          initialValues={{ markup: props.markup }}
          onFinish={onFinish}
        >
          <Form.Item name={'markup'}>
            <InputNumber<number>
              min={-100}
              max={100}
              size="large"
              formatter={(v) => `${v}%`}
              parser={(v) => Number(v?.replace('%', ''))}
            ></InputNumber>
          </Form.Item>

          <Form.Item>
            <RevxButton type="link" size="large" htmlType="submit">
              {t('common.save')}
            </RevxButton>
            <RevxButton
              type="link"
              size="large"
              onClick={() => props.onSave(null)}
            >
              {t('platform.markup.labels.setToNone')}
            </RevxButton>
          </Form.Item>
        </Form>
      )}
      <Descriptions style={{ marginTop: 8 }}>
        <Descriptions.Item label={t('platform.markup.labels.industryAvg')}>
          {props.industryAvg === null
            ? NOT_APPLICABLE
            : props.industryAvg + '%'}
        </Descriptions.Item>
      </Descriptions>
      {props.noMarkupCount > 0 ? (
        <RevxButton
          style={{ paddingLeft: 0 }}
          type="link"
          onClick={props.onJump}
        >
          {
            //@ts-ignore
            t(props.noMarkupLabel, { count: props.noMarkupCount })
          }
        </RevxButton>
      ) : (
        //@ts-ignore
        <p>{t(props.allMarkupLabel)}</p>
      )}
    </Card>
  );
};

export default ElementMarkupCard;
